import React from 'react';
import SIcon from './SIcon';
import { faEye } from '@fortawesome/pro-regular-svg-icons';

const Icon = props => <SIcon {...props} icon={faEye} fa />;

export default Icon;
